import { useQuery } from "@tanstack/react-query";
import { fetchEmailTemplateList } from "../../../utils/apiUtils";
import {
    OBSERVABILITY_LOG_PREFIXES,
    TEST_EMAIL_TEMPLATE_QUERY_KEYS,
} from "./constants";

/**
 * TanStack Query hook that fetches the enabled email template list for the Test Email Template form dropdown.
 * Issues a live `GET /notifications/sendDirectEmail/templates` call on every mount (no cache).
 * On load failure, emits a `console.error` and returns `isError: true` — the form disables
 * the Send button and surfaces an inline error with a Retry affordance.
 *
 * @returns {{
 *   templates: { template: string, enabled: true }[],
 *   isLoading: boolean,
 *   isError: boolean,
 *   refetch: () => void
 * }}
 */
export function useEmailTemplateList() {
    const query = useQuery({
        queryKey: [TEST_EMAIL_TEMPLATE_QUERY_KEYS.TEMPLATE_LIST_ROOT],
        queryFn: fetchEmailTemplateList,
    });

    if (query.isError) {
        const statusCode = query.error?.cause?.status ?? "";
        const message = query.error?.message ?? "";
        console.error(
            OBSERVABILITY_LOG_PREFIXES.TEMPLATES_LOAD_FAILED,
            statusCode,
            message
        );
    }

    const templates = query.data?.templates ?? [];

    return {
        templates,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch,
    };
}
